<template>
  <div>
    <!-- 头部start -->
    <crumbs :activeIndex="4"></crumbs>
    <!-- 头部 end-->
    <!-- 广告start -->
    <div class="y-advertisement">
      <img src="../../static/img/activet.png" alt />
    </div>
    <!-- 广告end -->
    <!-- 导航start -->
    <div class="y-navigation">
      <div class="min y-navigation-box">
        <div class="router-active">
          <img src="../../static/img/icon.png" alt=""><router-link to="/">首页 ></router-link>活动资讯><span style="color:#0078ff">{{actives}}</span>
        </div>
      </div>
    </div>
    <!-- 导航end -->

    <div class="popular-list min">
      <div class="popular-left">
        <!-- {{Name}} -->
        <div class="popular-box" v-for="(active,index) in activeList" :key="index">
          <div class="box" v-if="show">
            <div class="popular-b-img">
              <img :src="baseURL+active.Pic" alt />
            </div>
            <div class="popular-b-text">
              <router-link :to="{ path:'/activeDetail',query:{ id:active.Id } }" tag="span">
              <h3>{{active.Title}}</h3>
              <p>{{active.Intr}}</p>
              <div class="popular-b-time">
                <div class="popular-b-time-day"><img src="../../static/img/timeing.png" alt=""><span>{{active.LastUpdateDate}}</span></div>
                <div class="popular-b-time-look">
                  <router-link class="popular-b-time-looks" :to="{ path:'/activeDetail',query:{ id:active.Id } }" >
                   <span>查看详情</span>
                    <img src="../../static/img/right.png" alt />
                  </router-link>
                </div>
              </div>
                </router-link>
            </div>
          </div>
          <div class="box" v-if="shows">
            <div class="popular-b-img">
              <img :src="baseURL+active.Pic" alt />
            </div>

            <div class="popular-b-text">
              <router-link :to="{ path:'/activeDetail',query:{ id:active.Id } }" tag="span">
                <h3>{{active.Title}}</h3>
                <p>{{active.Intr}}</p>
                <div class="popular-b-time">
                  <div class="popular-b-time-day"><img src="../../static/img/timeing.png" alt=""><span>{{active.LastUpdateDate}}</span></div>
                  <div class="popular-b-time-look">
                     <router-link class="popular-b-time-looks" :to="{ path:'/activeDetail',query:{ id:active.Id,name:'活动资讯' } }" >
                   <span>查看详情</span>
                    <img src="../../static/img/right.png" alt />
                  </router-link>
                    </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="popular-right">
        <h3>活动资讯</h3>
        <div
          class="popular-r-text"
          :class="{active:index==activeIndex}"
          @click="press(index,item)"
          v-for="(item,index) in hover"
          :key="index"
        >
          <span>{{item.text}}</span>
          <img v-if="index==activeIndex" :class="{active:index==activeIndex}" src="../../static/img/arrow.png" alt />
          <img  v-else src="../../static/img/gray.png" alt />
        </div>
        <!-- <div class="popular-r-img">
          <img src="../../static/img/active2.png" alt />
        </div> -->
      </div>
    </div>
    <tab></tab>

    <!-- 友情链接end -->
    <Footer></Footer>
  </div>
</template>

<script>
import tab from "@/components/tab.vue";
export default {
  components: {
    tab
  },
  data() {
    return {
      actives:"科普活动",
      activeList: [],
      baseURL:window.SITE_CONFIG.baseUrl+'/yxht',
      Name: "",
      show: false,
      shows: true,
      hover: [{ text: "科普活动" }, { text: "新闻动态" }, { text: "公告通知" },{ text: "党建工作" }],
      activ: true,
      activcor: true,
      // activated: "",
      activeIndex: 0
    };
  },
  created() {
    this.activeFun();
    this.appiontFun();

  },
  mounted(){
    var query=this.$route.query;
    this.activeIndex=query.id;
    if(this.activeIndex==0){
        this.activeFun();
    }else if(this.activeIndex==1){
         this.newsFun();
    }else if(this.activeIndex==2){
        this.announcemenFun();
    }else if(this.activeIndex==3){
        this.activeConsultation();
    }
  },
  methods: {
    appiontFun() {
      this.$http
        .get("wxshopapi/ExpectScenic/GetList", {
          State: 1,
          page: 1,
          pagesize: 20
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.hotList = this.geared.rows; //热门展项

          console.log("966555:", this.hotList);
          // this.Intr = this.service.rows.Intr;
        });
    },

    // 科普活动
    activeFun() {
      this.$http
        .get("yxapi/api/News/GetNewsList", {
          CategoryId: "d993922f-e404-49e1-967c-43f56e104e79",
          page: 1,
          size: 9
        })
        .then(res => {
          this.active = JSON.parse(res.data.Result);
             console.log( 5555, this.active )
          this.activeList = this.active.rows;
          console.log(911119,this.activeList)
        });
    },
    //新闻动态
    newsFun() {
      this.$http
        .get("yxapi/api/News/GetNewsList", {
          CategoryId: "5eb73fde-b433-49f7-9720-58e177d8f855",
          page: 1,
          size: 9
        })
        .then(res => {
          this.active = JSON.parse(res.data.Result);

          this.activeList = this.active.rows;
        });
    },
    // fb26c538-8d1e-4808-80f6-9f1a1476b8d7
    // 公告
    announcemenFun() {
      this.$http
        .get("yxapi/api/News/GetNewsList", {
          CategoryId: "fb26c538-8d1e-4808-80f6-9f1a1476b8d7",
          page: 1,
          size: 5
        })
        .then(res => {
          this.active = JSON.parse(res.data.Result);
          this.activeList = this.active.rows;
        });
    },
    //党建工作
   activeConsultation(){
  this.$http.get("yxapi/api/News/GetNewsList", {
          CategoryId: "c2b21904-2977-49dc-be4a-9ec758b65f89",
          page: 1,
          size: 5
        })
        .then(res => {

          var date= JSON.parse(res.data.Result);

           this.activeList = date.rows;
          console.log( this.activeList)

        });
    },
    press(index,item) {
      this.actives = item.text
      this.activeIndex = index;

        if(index==3){
        this.activeConsultation();
        return;
        }
      if (index == 0) {
        if (this.activated === "activated") {
          this.activated = "";
        } else {
          this.activated = "activated";
        }
        this.activeFun();
        this.show = false;
        this.shows = true;
      } else if (index == 1) {

        this.activ = !this.activ;
        this.newsFun();
        this.shows = false;
        this.show = true;
      } else {
        this.activ = !this.activ;
        this.announcemenFun();
        this.shows = false;
        this.show = true;

      }
    }
  }
};
</script>

<style scoped>
/* table样式
 */
 .router-active{
   display: flex;
   align-items: center;
   height: 60px;
 }
 .router-active img{
   width: 17px;
   height: 20px;
   margin-right: 6px;

 }
 .router-link-active{
   color: #000000;
 }
 .popular-b-time-day{
   display: flex;
   align-items: center;
 }
  .popular-b-time-day span{
   margin-left: 7px;
 }
 .popular-b-time-day img{
   width:18px;
   height: 18px;
 }
.popular-r-img img {
  width: 270px;
  height: 210px;
}
.activated {
  /* width: 100%;
  height: 89px; */
  background: #0078ff;
}
.activcor {
  color: orange;
}
.y-advertisement {
  width: 100%;
  height: 340px;
}
.y-advertisement img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.popular-list {
  display: flex;
  margin: 30px auto;
}
.popular-box {
  width: 876px;
  height: 186px;
  border: 1px solid #f2f2f2;
  /* padding-left: 30px; */
  display: flex;
  align-items: center;
}
.popular-box:active {
  background: rgba(0, 120, 255, 0.1);
}
.box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
/* .popular-box:nth-child(2n) {
  background: rgba(0, 120, 255, 0.1);
} */
.popular-box .popular-b-img {
  width: 203px;
  height: 126px;
  margin-left: 20px;
  /* background-color: red; */
}
.popular-b-img img {
  width: 203px;
  height: 126px;

}
.popular-b-text {
  width: 75%;
  margin-left: 26px;
}
.popular-box h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
}
.popular-b-text p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 设置行数 */
  -webkit-box-orient: vertical;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 34px;
}
.popular-b-time {
  display: flex;
  justify-content: space-between;
}
.popular-b-time {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin-top: 29px;
}
.popular-b-time-looks{
  display: flex;
  align-items: center;
  color: #666666;
}
.popular-b-time-look img {
  /* display: inline-block; */
  width: 14px;
  height: 14px;
  /* vertical-align: middle; */
  margin-left:6px ;
}
.popular-right {
  width: 270px;
height: 415px;
background: #FFFFFF;
box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
border-radius: 10px;
  margin-left: 40px;
}
.popular-right h3 {
  height: 85px;
  line-height: 85px;

  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
.popular-right .popular-r-text {
  padding: 0 20px;
  font-size: 18px;
  height: 60px;
  line-height: 60px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popular-r-text.active {
  color: #fff;
  background-color: #0078ff;
}
.popular-r-text img{
  width:18px;
  height: 18px;
}
.popular-right .popular-r-text img {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
/* background: #0078FF; */
</style>



// WEBPACK FOOTER //
// src/view/ActivityConsultation.vue